import React, { useState, useMemo, useEffect } from 'react';
import {
  buttonBackgroundClasses,
  buttonInvertedClasses,
} from '../../../atoms/button/buttonColors';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const getFilterButtons = (filtersData) =>
  filtersData?.map((button, i) => {
    return {
      id: button.id,
      name: button.categoryName,
      colorClasses: buttonBackgroundClasses[i % buttonBackgroundClasses.length],
      invertedColorClasses:
        buttonInvertedClasses[i % buttonInvertedClasses.length],
      categoryDbName: button.categoryDbName,
    };
  });

const AlternativeFilters = ({ filtersData, onFilterChange, t }) => {
  const maxButtonDisplay = 5;
  const [activeFilters, setActiveFilters] = useState({});
  const [showAllFilters, setShowAllFilters] = useState(false);

  const handleFilterClick = (categoryDbName) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [categoryDbName]: !prevFilters[categoryDbName],
    }));
  };

  const filterButtons = useMemo(
    () => getFilterButtons(filtersData),
    [filtersData]
  );

  const displayedFilters = useMemo(() => {
    if (filterButtons.length >= 8) {
      return showAllFilters
        ? filterButtons
        : filterButtons.slice(0, maxButtonDisplay);
    } else {
      return filterButtons;
    }
  }, [filterButtons, showAllFilters]);

  useEffect(() => {
    onFilterChange(activeFilters);
  }, [activeFilters, onFilterChange]);

  if (!filterButtons.length || filterButtons.length < 2) {
    return null;
  }

  return (
    <div>
      <div className="flex gap-2 flex-wrap justify-center">
        {displayedFilters.map((filter) => {
          const isActive = activeFilters[filter.categoryDbName];

          const combinedClasses = isActive
            ? `${filter.invertedColorClasses}`
            : `${filter.colorClasses}`;

          return (
            <LinkButton
              key={filter.id}
              onClick={() => handleFilterClick(filter.categoryDbName)}
              size="lg"
              className={`m-1 ${combinedClasses} font-bold`}
              label={filter.name}
              variant={isActive ? 'borderOnly' : 'default'}
            />
          );
        })}

        {filterButtons.length >= 8 && (
          <LinkButton
            key={'filterButtons'}
            onClick={() => setShowAllFilters(!showAllFilters)}
            size="lg"
            className={`m-1 border-gray-200 text-gray-700 font-bold`}
            label={showAllFilters ? t('common.showLess') : t('common.showMore')}
            variant={'borderOnly'}
          />
        )}
      </div>
    </div>
  );
};

export default AlternativeFilters;
